export const dutyCertCategories = {
  A: 'Textile Spare Parts',
  B: 'Dyes Chemicals',
  C: 'Textile Spare Parts For Machineries',
};

export const MAX_BLANK_CERTIFICATE_COUNT = 1000;
